import _ from 'lodash'
import useOnInit from './useOnInit'

export const getBackgroundFormData = props => {
  const {
    user,
    proposalType,
    setting
  } = props

  const applicant = _.get(user, 'identity.name', '')
  const formData = {
    applicant,
    type: proposalType,
    setting
  }
  return formData
}

// 批次更新提案會寫入提案背景資料到 proposal form
const useBackgroundFormData = (props, callback) => {
  useOnInit(() => {
    const formData = getBackgroundFormData(props)
    callback(formData)
  })
}

export default useBackgroundFormData
